import type { RentalSearchValue } from '../models.js';

/** Um campo da barra do rent a car que ainda não foi respondido. */
export type RentalSearchPendingField = 'pickupPlace' | 'dropoffPlace' | 'pickupAt' | 'dropoffAt';

/**
 * O que falta responder, NA ORDEM em que a fileira pergunta (lugares antes das
 * datas) — o primeiro item é sempre "o próximo campo pendente", e a lista
 * vazia é o `Buscar` liberado.
 *
 * O lugar da devolução só conta em `dropoffMode: 'different'`: no mesmo lugar o
 * campo nem existe na tela, e um `dropoffPlace` que tenha sobrado de uma troca
 * de modo não é pergunta em aberto.
 */
export function pendingRentalSearchFields(
  value: RentalSearchValue,
): readonly RentalSearchPendingField[] {
  const pending: RentalSearchPendingField[] = [];
  if (!value.pickupPlace) pending.push('pickupPlace');
  if (value.dropoffMode === 'different' && !value.dropoffPlace) pending.push('dropoffPlace');
  if (!value.pickupAt) pending.push('pickupAt');
  if (!value.dropoffAt) pending.push('dropoffAt');
  return pending;
}
